// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Mp-N","header":"ReportDetails_header__1QKes","title":"ReportDetails_title__3Le1F","left":"ReportDetails_left__36BpP"};